<template>
    <v-container>
        <FormularioCadastroTipoCotas :tipo-cota-edicao="tipo_cota_para_editar" @resetEdicao="limpaTipoCotaEdicao" @registroInserido="registroInserido" />
        <ListagemTipoCotas @editar="editarTipoCota" :atualiza-listagem="atualiza_listagem" />
    </v-container>
</template>
<script>
  import FormularioCadastroTipoCotas from '../../../components/cadastros/tipo-cotas/FormularioCadastroTipoCotas.vue'
  import ListagemTipoCotas from '../../../components/cadastros/tipo-cotas/ListagemTipoCotas.vue'
  export default {
    name: 'TiposCotas',
    components: { FormularioCadastroTipoCotas, ListagemTipoCotas },
    data () {
      return {
        tipo_cota_para_editar: null,
        atualiza_listagem: false
      }
    },
    methods: {
      limpaTipoCotaEdicao () {
        this.tipo_cota_para_editar = null
      },
      editarTipoCota (item) {
        this.tipo_cota_para_editar = item
      },
      registroInserido () {
        this.atualiza_listagem = !this.atualiza_listagem
      }
    }
  }
</script>
